// eslint-disable-next-line import/prefer-default-export
export enum FOLDERS {
	FOLDERS_LOAD_START = 'FOLDERS_LOAD_START',
	FOLDERS_LOAD_DONE = 'FOLDERS_LOAD_DONE',
	FOLDERS_LOAD_FAIL = 'FOLDERS_LOAD_FAIL'
}
